import _ from 'lodash';
import {MODALS} from 'common/domain/constants';

class cadastralReferenceFormController {
  constructor
  ($window,
   $rootScope,
   $state,
   $scope,
   EventEmitter,
   LoansUserDataService,
   LoansOperationsService,
   mainMenuMobileBehaviourService,
   loadingMobileService,
   floatingActionButtonsService,
   $timeout) {
    'ngInject';
    this.window = $window;
    this.rootScope = $rootScope;
    this.state = $state;
    this.scope = $scope;
    this.EventEmitter = EventEmitter;
    this.loansUserDataService = LoansUserDataService;
    this.loansOperationsService = LoansOperationsService;
    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
    this.loadingMobileService = loadingMobileService;
    this.floatingActionButtonsService = floatingActionButtonsService;

    this.modeRead = false;
    this.cadastralReference = {};
    this.timeout = $timeout;
  }

  $onInit() {
    this.init();

    $(MODALS.MY_LOANS).on('show.bs.modal', () => {
      this.timeout(() => {
        this.init();
      });
    });

    if (this.isMobileApp) {
      this._initFloatinButtons();
      this.mainMenuMobileBehaviourService.setCustomBehaviour(() => {
        const dataCadastral = {
          tempLoanObject: this.formatCadastralReference(),
          isCadastralCorrect: this.isCadastralCorrect,
        };
        this.showModalQuestion(this.EventEmitter(dataCadastral));
      });
    }
  }

  init() {
    if (!_.isEmpty(this.tempLoanObject)) {
      this.cadastralReference = this.tempLoanObject;
    }

    if (!_.isEmpty(this.loan.cadastralReference)) {
      this.setDataCadastral();
    } else {
      this.isCadastralCorrect = false;
    }

    this.onChangeDataForm();
  }

  _initFloatinButtons() {
    this.floatingActionButtons = this.getFloatingActionButtons();
    this.setFloatingActionButtonsDisabled();
  }

  getClasses() {
    return {
      'responsiveMobile': this.isMobileApp,
    };
  }

  submitForm() {
    const employeeId = this.loansUserDataService._employee.userId;
    this.saveCadastral(employeeId);
  }

  saveCadastral(employeeId) {
    const params = this.formatCadastralReference();
    this.loadingMobileService.show();
    this.loansOperationsService.putCadastralReference(employeeId, params).then(() => {
      this.onSave(this.EventEmitter({error: 'approve'}));
      this.isCadastralCorrect = true;
      this.modeRead = true;
    }).catch(response => {
      this.onSave(this.EventEmitter({error: 'failed', messageError: response.data.message}));
    }).finally(() => {
      this.loadingMobileService.hide();
    });
  }

  onChangeDataForm() {
    if (!this.isMobileApp) {
      const cadastralRef = this.tempLoanObject || this.cadastralReference || this.formatCadastralReference().cadastralReferences[0];
      const dataForm = {
        cadastralReference: cadastralRef,
        isCadastralCorrect: this.isCadastralCorrect,
      };

      this.onChangeForm(this.EventEmitter(dataForm));
    }
  }

  formatCadastralReference() {
    return {
      cadastralReferences: [
        {
          postalCode: this.cadastralReference.postalCode,
          complementaryInformation: this.cadastralReference.complementaryInformation,
          identifying: parseInt(this.loan.identifying) || parseInt(this.loanResponseId),
          township: this.cadastralReference.township,
          streetName: this.cadastralReference.streetName,
          cadastralReference: this.cadastralReference.cadastralReference,
        },
      ],
    };
  }

  setFloatingActionButtonsDisabled() {
    this.scope.$watch(() => this.cadastralForm.$invalid, newValue => {
      this.floatingActionButtons[0].disabled = newValue;
    });
    this.scope.$watch(() => this.modeRead, newValue => {
      this.floatingActionButtons[0].disabled = newValue;
    });
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.SAVE'
      }
    ];
  }

  isNotInputFocus() {
    return this.floatingActionButtonsService.isFocused;
  }

  checkCadastralReferenceCorrect() {
    let isNotEmptyCadastralReference = !!this.loan.cadastralReference.cadastralReference
      && !!this.loan.cadastralReference.streetName
      && !!this.loan.cadastralReference.township
      && !!this.loan.cadastralReference.postalCode;

    if (isNotEmptyCadastralReference) {
      this.isCadastralCorrect = true;
      this.modeRead = true;
    }
  }

  setDataCadastral() {
    this.checkCadastralReferenceCorrect();

    this.cadastralReference = {
      cadastralReference: this.loan.cadastralReference.cadastralReference,
      streetName: this.loan.cadastralReference.streetName,
      township: this.loan.cadastralReference.township,
      postalCode: this.loan.cadastralReference.postalCode,
      complementaryInformation: this.loan.cadastralReference.complementaryInformation,
    };

  }
}

export default cadastralReferenceFormController;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/cadastralReferenceForm/cadastralReferenceForm.controller.js